export enum PaymentMethod {
    Check = 1,
    CreditCard = 2,
    ElectronicTransfer = 3
}
